// Define a central list of all available categories
export const productCategories = [
    { id: 1, name: 'Mobiele app', icon: 'mobile-alt' },
    { id: 2, name: 'Dashboards', icon: 'chart-line' },
    { id: 3, name: 'API-koppelingen', icon: 'plug' },
    { id: 4, name: 'Automatisering', icon: 'robot' },
    { id: 5, name: 'Webapplicatie', icon: 'window' },
    { id: 6, name: 'CMS systeem', icon: 'newspaper' },
    { id: 7, name: 'Betaalsysteem', icon: 'credit-card' },
    { id: 8, name: 'Evenementenbeheer', icon: 'calendar-days' },
    { id: 9, name: 'Reserveringssysteem', icon: 'bookmark' },
];

export const products = [
    { 
        // Metadata group
        meta: {
            id: 1, 
            name: "SJHT", 
            icon: 'house-building',
            href: "https://www.sjht.nl",
            logo: "/img/projects/sjht/sjht-logo.svg",
            showInHeader: true,
            categoryIds: [1, 3],
            slug: 'sjht',
            metaDescription: 'SJHT is een innovatief platform waar studenten en verhuurders samen komen voor een naadloze huisvestingservaring.'
        },
        
        // Text content group
        content: {
            title: "Stichting Jongeren Huisvesting Twente",
            subTitle: "Slimme huisvesting",
            description: 'Platform voor studentenhuisvesting in Twente, waarmee huurders zaken als reparaties, facturen en communicatie met SJHT kunnen regelen via een app en website.',
            longDescription: 'SJHT is een platform voor studentenhuisvesting in Twente, waar huurders eenvoudig zaken als reparaties, facturen en communicatie met SJHT kunnen regelen via een gebruiksvriendelijke app en website. Voor dit project hebben we samengewerkt met Stichting Jongeren Huisvesting Twente om huurders te voorzien van een praktische en overzichtelijke oplossing voor het beheer van hun huisvesting. Het platform maakt het mogelijk om snel en efficiënt huurzaken te regelen en zorgt voor een directe verbinding met de verhuurder voor al hun behoeften.',
            subDescription: "Ja, SJHT regelt dat.",
            extraInfo: "Met het SJHT-platform kunnen huurders alles regelen met betrekking tot hun huisvesting op een centrale plek. Of het nu gaat om het melden van reparaties, het inzien van facturen of het onderhouden van communicatie met de verhuurder, alles is eenvoudig en snel toegankelijk via zowel de app als de website. Het platform is ontworpen met het oog op gemak en gebruiksvriendelijkheid, waardoor huurders niet langer hoeven te wachten op lange reactietijden of onduidelijke communicatie. Het biedt een snelle en directe manier om zaken te regelen, zodat studenten zich kunnen concentreren op hun studie en niet op administratieve taken.",
            hoverCta: "Slim gebouwd, klik en kijk"
        },
        
        // Styling group
        style: {
            projectColor: "sjht",
            mainColor: "#DE6F79"
        },
        
        // Media group
        media: {
            image: "/img/projects/iMac_24_inch_zilver.webp", 
            sliderImage: "/img/projects/sjht/showcaseCard.webp",
            productsPageImage: '/img/projects/sjht/projectpageImage.webp',
            mockupImages: {
                mid: {
                    src: "https://www.apple.com/v/mac/mac-does-that/i/images/overview/hero/hero_imac__fkl0k65jazyq_xlarge_2x.png",
                    alt: "Visualisatie van het platform op desktop"
                },
                left: {
                    src: "https://www.apple.com/v/mac/mac-does-that/i/images/overview/hero/hero_macbook_pro__dxwubu2fr8ia_xlarge_2x.png",
                    alt: "Desktopweergave van het platform"
                },
                right: {
                    src: "https://www.apple.com/v/mac/mac-does-that/i/images/overview/hero/hero_macbook_air__og7y4ihieoa6_xlarge_2x.png",
                    alt: "Mobiele weergave van het platform"
                }
            }
        },
        
        // Add testimonial
        testimonial: {
            question1: "Wat was het grootste misverstand dat je vóór ons nog over 'een goede website' had?",
            answer1: "We dachten dat een studentenplatform vooral fancy en hip moest zijn. Maar jullie hebben ons laten zien dat gebruiksgemak en duidelijkheid veel belangrijker zijn. Studenten willen vooral snel vinden wat ze zoeken.",
            
            question2: "Hoe hebben we jouw idee voor 'snel en simpel' vertaald naar de schermen?",
            answer2: "De app is zo intuïtief geworden dat nieuwe huurders nauwelijks uitleg nodig hebben. Alles wijst zichzelf, van reparatieverzoeken tot het inzien van facturen. Dat was precies wat we wilden: geen gedoe, gewoon doen.",
            
            question3: "Welke functionaliteit heeft volgens jou de grootste impact gehad?",
            answer3: "De geïntegreerde reparatiemodule heeft ons enorm veel tijd bespaard. Studenten kunnen direct foto's uploaden, hun probleem aangeven en de status volgen. Hierdoor is het aantal telefoontjes met 60% gedaald en worden reparaties sneller afgehandeld.",
            
            question4: "Wanneer dacht je: Oei, dit wordt écht goed?",
            answer4: "Toen we de eerste beta-versie testten met een groep studenten en zij binnen 5 minuten al enthousiast aan het klikken waren zonder vragen te stellen. Hun spontane reacties bevestigden dat we op de juiste weg zaten.",
            
            question5: "Stel, je belt je toekomstige zelf over deze samenwerking. Wat zeg je dan?",
            answer5: "'Maak je geen zorgen, het platform groeit met jullie mee.' De flexibiliteit van het systeem heeft ons aangenaam verrast - we blijven samen nieuwe functies ontwikkelen die aansluiten bij wat onze studenten nodig hebben.",
            
            author: "Lisa van der Veen",
            role: "Directeur",
            project: "Huurdersbeheer Systeem",
            image: "https://d66.nl/enschede/wp-content/uploads/sites/133/2022/01/Linsey-van-der-Veen-portret-aangepast-scaled.jpg"
        },
        
        // Content sections
        sections: {
            showcase: {
                1: {
                    title: 'Showcase benaming',
                    description: 'Showcase uitleg komt hier te staan',
                    image: "https://images.unsplash.com/photo-1599202875854-23b7cd490ff4?q=80&w=2382&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
                },
                2: {
                    title: 'Showcase benaming',
                    description: 'Showcase uitleg komt hier te staan',
                    image: "https://images.unsplash.com/photo-1441015401724-70d16b783f5c?q=80&w=2940&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
                },
                3: {
                    title: 'Showcase benaming',
                    description: 'Showcase uitleg komt hier te staan',
                    image: "https://images.unsplash.com/photo-1511376777868-611b54f68947?q=80&w=2940&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
                },
            },
            bentoGrid: [
                {
                    title: "Platform",
                    heading: "Huurdersbeheer",
                    description: "Centraal platform voor huurders om reparaties aan te vragen, betalingen te beheren en communicatie met verhuurder te stroomlijnen."
                },
                {
                    title: "Integraties",
                    heading: "Alles verbonden",
                    description: "Koppeling met administratiesystemen, betaalsystemen en mobiele communicatieplatforms voor een naadloze ervaring.",
                    integrations: [
                        {
                            name: "Vastware Pro",
                            icon: "https://cdn-icons-png.flaticon.com/512/2830/2830284.png",
                        },
                        {
                            name: "RepairDesk",
                            icon: "https://cdn-icons-png.flaticon.com/512/1077/1077198.png",
                        },
                        {
                            name: "iDeal",
                            icon: "https://upload.wikimedia.org/wikipedia/commons/thumb/8/87/Logo_iDEAL.svg/1200px-Logo_iDEAL.svg.png",
                        },
                        {
                            name: "DUO",
                            icon: "https://www.duo.nl/binaries/content/gallery/duo/content-afbeeldingen/images/l/logo-dienst-uitvoering-onderwijs-duo.svg",
                        },
                        {
                            name: "HuisMessenger",
                            icon: "https://cdn-icons-png.flaticon.com/512/1041/1041916.png",
                        }
                    ]
                },
                {
                    title: "Veiligheid",
                    heading: "Bescherming voorop",
                    description: "Persoonlijke gegevens beschermd met end-to-end encryptie en strikte toegangscontrole voor gebruikersdata."
                },
                {
                    title: "Gebruikservaring",
                    heading: "Ontworpen voor eenvoud",
                    description: "Intuïtieve interface die zowel op desktop als mobiele apparaten een soepele gebruikerservaring biedt."
                }
            ]
        }
    },
    
    { 
        meta: {
            id: 2, 
            name: "Mijn Auto Snel Weg",
            icon: 'car-building',
            href: "https://www.mijnautosnelweg.nl",
            logo: "/img/projects/mas/mas-logo.svg",
            showInHeader: true,
            categoryIds: [4, 6],
            slug: 'mijn-auto-snel-weg',
            metaDescription: 'Mijn Auto Snelweg biedt een innovatief platform waar particulieren hun auto snel en eenvoudig kunnen verkopen aan dealers voor de beste prijs.'
        },
        
        content: {
            title: "Mijn Auto snel weg", 
            subTitle: "Verkoop  je auto snel online",
            description: "Verkoopplatform voor auto's, waar particulieren hun auto aanbieden en dealers op auto's kunnen bieden om de beste verkoopprijs te krijgen.",
            longDescription: "Mijn Auto Snel weg is een verkoopplatform dat particulieren in staat stelt hun auto eenvoudig aan te bieden aan dealers. Dit platform biedt de mogelijkheid om snel biedingen van verschillende dealers te ontvangen, zodat de verkoper de beste prijs kan kiezen. We hebben dit project ontwikkeld met de focus op eenvoud en snelheid, zodat het verkoopproces voor auto's gemakkelijk en stressvrij is.",
            subDescription: "Ja, Mijn Auto Snel weg doet dat.",
            extraInfo: "Mijn Auto Snel weg biedt een eenvoudige en gebruiksvriendelijke oplossing voor de verkoop van jouw auto. Via het platform kunnen particulieren snel hun voertuig aanbieden en binnen enkele uren biedingen ontvangen van geverifieerde autodealers. Het platform is ontworpen om het proces zo soepel mogelijk te laten verlopen, van het plaatsen van de auto tot het ontvangen van de hoogste bieding. Dit bespaart zowel tijd als moeite voor de verkoper, terwijl de koper verzekerd is van een eerlijke prijs. Het platform is de ideale manier voor iedereen die zijn auto snel en tegen de beste prijs wil verkopen.",
            hoverCta: "Van idee tot impact"
        },
        
        style: {
            projectColor: "mijnautosnel weg",
            mainColor: "#282DA5"
        },
        
        media: {
            image: "/img/projects/iMac_24_inch_zilver.webp", 
            sliderImage: "/img/projects/mas/showcaseCard.webp",
            productsPageImage: '/img/projects/mas/projectpageImage.webp',
            mockupImages: {
                mid: {
                    src: "https://www.apple.com/v/mac/mac-does-that/i/images/overview/hero/hero_imac__fkl0k65jazyq_xlarge_2x.png",
                    alt: "Visualisatie van het platform op desktop"
                },
                left: {
                    src: "https://www.apple.com/v/mac/mac-does-that/i/images/overview/hero/hero_macbook_pro__dxwubu2fr8ia_xlarge_2x.png",
                    alt: "Desktopweergave van het platform"
                },
                right: {
                    src: "https://www.apple.com/v/mac/mac-does-that/i/images/overview/hero/hero_macbook_air__og7y4ihieoa6_xlarge_2x.png",
                    alt: "Mobiele weergave van het platform"
                }
            }
        },
        
        // Add testimonial
        testimonial: {
            question1: "Wat was het grootste misverstand dat je vóór ons nog over 'een goede website' had?",
            answer1: "Er waren niet per se misverstanden, maar wat we heel prettig vonden, is dat alles wat niet direct duidelijk was, meteen werd teruggekoppeld. Er werd overlegd, afgestemd en zo kwamen we samen steeds tot de juiste oplossing.",
            
            question2: "Hoe hebben we jouw idee voor 'snel en simpel' vertaald naar de schermen?",
            answer2: "'Snel en simpel' zie je echt terug in het hele concept van ons platform. Vanaf het moment dat een verkopende klant op de website komt, krijgt die het gevoel dat alles vanzelf gaat. De flow is intuïtief en moeiteloos — precies wat we voor ogen hadden.",
            
            question3: "Welke functionaliteit heeft volgens jou de meeste auto's van eigenaar doen wisselen?",
            answer3: "De aanpassing van het aanmeldformulier, vooral stap 1 t/m 4, heeft een groot verschil gemaakt. Klanten werden op een slimme manier door het proces geleid en kozen er daardoor vaker voor om hun auto daadwerkelijk aan te melden. Dat zorgde voor meer leads — en dus meer auto's die van eigenaar wisselden.",
            
            question4: "Wanneer dacht je: Oei, dit wordt écht goed?",
            answer4: "Dat moment kwam toen Emiel bijna klaar was met het coderen van het platform. Toen zagen we voor het eerst écht hoe MAS eruit zou komen te zien. Dat was gaaf — en gaf vertrouwen dat het iets bijzonders zou worden.",
            
            question5: "Stel, je belt je toekomstige zelf over deze samenwerking. Wat zeg je dan?",
            answer5: "'We blijven samen doorgaan.' Want dit voelt als een samenwerking waar nog veel moois uit kan komen.",
            
            author: "Mark Jansen",
            role: "Inkoper",
            project: "Dealer Platform",
            image: "/img/testimonials/mark-jansen.jpg"
        },
        
        sections: {
            showcase: {
                1: {
                    title: 'Showcase benaming',
                    description: 'Showcase uitleg komt hier te staan',
                    image: "https://images.unsplash.com/photo-1599202875854-23b7cd490ff4?q=80&w=2382&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
                },
                2: {
                    title: 'Showcase benaming',
                    description: 'Showcase uitleg komt hier te staan',
                    image: "https://images.unsplash.com/photo-1441015401724-70d16b783f5c?q=80&w=2940&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
                },
                3: {
                    title: 'Showcase benaming',
                    description: 'Showcase uitleg komt hier te staan',
                    image: "https://images.unsplash.com/photo-1511376777868-611b54f68947?q=80&w=2940&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
                },
            },
            bentoGrid: [
                {
                    title: "Verkoop",
                    heading: "Directe biedingen",
                    description: "Ontvang binnen enkele uren meerdere biedingen van geverifieerde autodealers op je te verkopen voertuig."
                },
                {
                    title: "Integraties",
                    heading: "Alles verbonden",
                    description: "Naadloze koppelingen met RDW, verzekeringsmaatschappijen en financiële dienstverleners.",
                    integrations: [
                        {
                            name: "RDW Connect",
                            icon: "https://upload.wikimedia.org/wikipedia/commons/thumb/9/94/Logo_RDW.svg/1200px-Logo_RDW.svg.png",
                        },
                        {
                            name: "AutoScout24",
                            icon: "https://upload.wikimedia.org/wikipedia/commons/thumb/7/73/AutoScout24_logo.svg/2560px-AutoScout24_logo.svg.png",
                        },
                        {
                            name: "BPM Calculator",
                            icon: "https://cdn-icons-png.flaticon.com/512/2344/2344156.png",
                        },
                        {
                            name: "Marktplaats",
                            icon: "https://upload.wikimedia.org/wikipedia/commons/thumb/e/e6/Marktplaats_logo.svg/1200px-Marktplaats_logo.svg.png",
                        },
                        {
                            name: "BOVAG",
                            icon: "https://upload.wikimedia.org/wikipedia/commons/thumb/7/72/BOVAG_logo.svg/1200px-BOVAG_logo.svg.png",
                        }
                    ]
                },
                {
                    title: "Veiligheid",
                    heading: "Veilige transacties",
                    description: "Beveiligde transacties en verificatieprocessen zorgen voor een betrouwbare ervaring voor kopers en verkopers."
                },
                {
                    title: "Prestaties",
                    heading: "Razendsnelle matching",
                    description: "Geavanceerd algoritme matcht auto's aan de juiste kopers voor een optimale prijs in minimale tijd."
                }
            ]
        }
    },
    
    { 
        meta: {
            id: 3, 
            name: "sam/sam", 
            icon: 'books',
            href: "https://www.sam-sam.online",
            logo: "/img/projects/samsam/samsam-logo.svg",
            showInHeader: true,
            categoryIds: [1, 2],
            slug: 'sam-sam',
            metaDescription: 'SamSam is een innovatieve digitale leeromgeving die het onderwijsproces transformeert door studenten en docenten samen te brengen op één intuïtief platform.'
        },
        
        content: {
            title: "sam/sam hybride educatieplatform",
            subTitle: "Hybride educatie",
            description: 'Hybride educatieplatform voor buitenschoolse activiteiten, waar leerlingen hun voortgang kunnen bijhouden en leraren opdrachten kunnen delen en beoordelen.',
            longDescription: 'Sam/sam is een hybride educatieplatform dat speciaal is ontwikkeld voor buitenschoolse activiteiten. Het biedt zowel leerlingen als leraren de tools die ze nodig hebben om het onderwijsproces beter te beheren. Leerlingen kunnen hun voortgang volgen, terwijl leraren opdrachten kunnen delen en beoordelen. Dit platform is ontworpen om zowel op school als thuis gebruikt te worden, zodat leerlingen hun leerproces op hun eigen tempo kunnen voortzetten. We hebben gewerkt aan een flexibele interface die het leren gemakkelijk maakt, ongeacht de locatie.',
            subDescription: "Ja, sam/sam ondersteunt dat.",
            extraInfo: "Sam/sam biedt een innovatieve oplossing voor hybride leren door zowel leerlingen als leraren de mogelijkheid te geven hun educatieve processen efficiënt te beheren. Het platform maakt het voor leerlingen mogelijk om hun voortgang te volgen, opdrachten te voltooien en feedback te ontvangen, zowel op school als thuis. Leraren kunnen eenvoudig lesmateriaal en opdrachten delen, en de voortgang van hun leerlingen monitoren. Het systeem bevordert zelfgestuurd leren, waarbij leerlingen in hun eigen tempo kunnen werken, en zorgt voor een naadloze overgang tussen school- en thuissituaties.",
            hoverCta: "Flexibel proces, stevig resultaat"
        },
        
        style: {
            projectColor: "samsam",
            mainColor: "#57ABFE"
        },
        
        media: {
            image: "/img/projects/iMac_24_inch_zilver.webp", 
            sliderImage: "/img/projects/samsam/showcaseCard.webp",
            productsPageImage: '/img/projects/samsam/projectpageImage.webp',
            mockupImages: {
                mid: {
                    src: "https://www.apple.com/v/mac/mac-does-that/i/images/overview/hero/hero_imac__fkl0k65jazyq_xlarge_2x.png",
                    alt: "Visualisatie van het platform op desktop"
                },
                left: {
                    src: "https://www.apple.com/v/mac/mac-does-that/i/images/overview/hero/hero_macbook_pro__dxwubu2fr8ia_xlarge_2x.png",
                    alt: "Desktopweergave van het platform"
                },
                right: {
                    src: "https://www.apple.com/v/mac/mac-does-that/i/images/overview/hero/hero_macbook_air__og7y4ihieoa6_xlarge_2x.png",
                    alt: "Mobiele weergave van het platform"
                }
            }
        },
        
        // Add testimonial
        testimonial: {
            question1: "Wat was het grootste misverstand dat je vóór ons nog over 'een goede website' had?",
            answer1: "Ik dacht dat een educatief platform per definitie complex moest zijn om alle onderwijsfuncties te ondersteunen. Jullie hebben bewezen dat eenvoud en duidelijkheid juist leiden tot betere educatieve resultaten.",
            
            question2: "Hoe hebben we jouw idee voor 'snel en simpel' vertaald naar de schermen?",
            answer2: "Jullie hebben een interface ontworpen die zowel voor leerlingen als docenten direct begrijpelijk is. De opdrachtenmodule is zo intuïtief dat nieuwe gebruikers binnen enkele minuten aan de slag kunnen, zonder uitgebreide handleidingen.",
            
            question3: "Welke functionaliteit heeft volgens jou de grootste impact op het leerproces gehad?",
            answer3: "De real-time feedback functie heeft een revolutie teweeggebracht in hoe onze docenten communiceren met leerlingen. Ze kunnen nu direct reageren op ingediend werk, wat het leerproces enorm versnelt en de betrokkenheid vergroot.",
            
            question4: "Wanneer dacht je: Oei, dit wordt écht goed?",
            answer4: "Tijdens de eerste pilotweek met enkele klassen zagen we dat de activiteit op het platform ook na schooltijd doorging. Leerlingen werkten vrijwillig verder aan opdrachten omdat de interface zo prettig werkte. Dat was het moment waarop ik wist: dit is wat we nodig hebben.",
            
            question5: "Stel, je belt je toekomstige zelf over deze samenwerking. Wat zeg je dan?",
            answer5: "'Blijf investeren in deze samenwerking, het rendement is veel meer dan je verwacht.' De combinatie van jullie technische expertise en onze onderwijskennis heeft een platform opgeleverd dat echt het verschil maakt.",
            
            author: "Dr. Annemarie de Boer",
            role: "Onderwijscoördinator",
            project: "Hybride Leeromgeving",
            image: "/img/testimonials/annemarie-deboer.jpg"
        },
        
        sections: {
            showcase: {
                1: {
                    title: 'Showcase benaming',
                    description: 'Showcase uitleg komt hier te staan',
                    image: "https://images.unsplash.com/photo-1599202875854-23b7cd490ff4?q=80&w=2382&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
                },
                2: {
                    title: 'Showcase benaming',
                    description: 'Showcase uitleg komt hier te staan',
                    image: "https://images.unsplash.com/photo-1441015401724-70d16b783f5c?q=80&w=2940&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
                },
                3: {
                    title: 'Showcase benaming',
                    description: 'Showcase uitleg komt hier te staan',
                    image: "https://images.unsplash.com/photo-1511376777868-611b54f68947?q=80&w=2940&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
                },
            },
            bentoGrid: [
                {
                    title: "Educatie",
                    heading: "Flexibel leren",
                    description: "Volg lessen in je eigen tempo, waar en wanneer het jou uitkomt met een gepersonaliseerd leerpad."
                },
                {
                    title: "Integraties",
                    heading: "Verbonden systemen",
                    description: "Naadloze integratie met schoolsystemen, leerlingvolgsystemen en communicatieplatforms.",
                    integrations: [
                        {
                            name: "Magister",
                        },
                        {
                            name: "Google Classroom",
                            icon: "https://upload.wikimedia.org/wikipedia/commons/thumb/2/25/Google_Classroom_icon.svg/1200px-Google_Classroom_icon.svg.png",
                        },
                        {
                            name: "Moodle",
                            icon: "https://upload.wikimedia.org/wikipedia/commons/thumb/f/f0/Moodle-logo.svg/740px-Moodle-logo.svg.png",
                        },
                        {
                            name: "Microsoft Education",
                            icon: "https://img.icons8.com/color/452/microsoft.png",
                        },
                        {
                            name: "Zoom Classes",
                            icon: "https://upload.wikimedia.org/wikipedia/commons/thumb/9/9a/Zoom_logo.svg/2056px-Zoom_logo.svg.png",
                        }
                    ]
                },
                {
                    title: "Veiligheid",
                    heading: "Beschermde omgeving",
                    description: "Veilige leeromgeving met leeftijdsgeschikte content en privacy-by-design principes."
                },
                {
                    title: "Inzicht",
                    heading: "Voortgang volgen",
                    description: "Gedetailleerde voortgangsrapportages geven leraren en leerlingen inzicht in leerresultaten."
                }
            ]
        }
    },
    
    { 
        meta: {
            id: 4, 
            name: "MTF Automobielen", 
            icon: 'garage-car',
            href: "https://www.mtfautomobielen.nl",
            logo: "/img/projects/mtf/mtf-logo.svg",
            showInHeader: true,
            categoryIds: [3, 4],
            slug: 'mtf-automobielen'
        },
        
        content: {
            title: "MTF Automobielen",
            subTitle: "Specialist in gebruikte auto's",
            description: "Moderne website voor een autodealer met auto-uploadfuncties en een ingebouwde leencalculator voor een directe maandelijkse prijsindicatie.",
            longDescription: 'MTF Automobielen is een moderne website voor een autodealer die het mogelijk maakt om snel auto’s te kopen en verkopen. De website biedt een auto-uploadfunctie voor verkopers en een ingebouwde leencalculator voor kopers, zodat ze direct een indicatie krijgen van de maandlasten bij het afsluiten van een lening. Dit project is ontwikkeld om het koop- en verkoopproces van auto’s gemakkelijker te maken door technologie in te zetten die de klant helpt bij het nemen van de juiste beslissing.',
            subDescription: "Ja, MTF maakt dat eenvoudig.",
            extraInfo: "MTF Automobielen biedt een efficiënte en gebruiksvriendelijke manier voor zowel kopers als verkopers om hun zaken snel te regelen. Verkopers kunnen eenvoudig hun voertuigen uploaden naar de website, waar ze meteen zichtbaar zijn voor potentiële kopers. Voor kopers biedt de website een ingebouwde leencalculator waarmee ze direct een idee krijgen van de maandlasten bij het afsluiten van een lening. Dit bespaart tijd en maakt het proces van het kopen van een auto gemakkelijker en transparanter. Of je nu een auto wilt kopen of verkopen, het platform biedt alles wat je nodig hebt om snel en zonder gedoe de juiste keuze te maken.",
            metaDescription: 'MTF Automobielen is een moderne autodealer website die het koop- en verkoopproces van auto’s vereenvoudigt met geavanceerde technologie.',
            hoverCta: "Bekijk de volledige case"
        },
        
        style: {
            projectColor: "mtf",
            mainColor: "#FF7433"
        },
        
        media: {
            image: "/img/projects/iMac_24_inch_zilver.webp", 
            sliderImage: "/img/projects/mtf/showcaseCard.webp",
            productsPageImage: '/img/projects/mtf/projectpageImage.webp',
            mockupImages: {
                mid: {
                    src: "https://www.apple.com/v/mac/mac-does-that/i/images/overview/hero/hero_imac__fkl0k65jazyq_xlarge_2x.png",
                    alt: "Visualisatie van het platform op desktop"
                },
                left: {
                    src: "https://www.apple.com/v/mac/mac-does-that/i/images/overview/hero/hero_macbook_pro__dxwubu2fr8ia_xlarge_2x.png",
                    alt: "Desktopweergave van het platform"
                },
                right: {
                    src: "https://www.apple.com/v/mac/mac-does-that/i/images/overview/hero/hero_macbook_air__og7y4ihieoa6_xlarge_2x.png",
                    alt: "Mobiele weergave van het platform"
                }
            }
        },
        
        // Add testimonial
        testimonial: {
            question1: "Wat was het grootste misverstand dat je vóór ons nog over 'een goede website' had?",
            answer1: "Ik dacht altijd dat een autodealer website vooral veel foto's en specificaties moest tonen. Jullie hebben me laten inzien dat het draait om de customer journey en het wegnemen van obstakels in het aankoopproces.",
            
            question2: "Hoe hebben we jouw idee voor 'snel en simpel' vertaald naar de schermen?",
            answer2: "De leencalculator is precies wat ik bedoelde met 'snel en simpel'. Klanten kunnen nu direct zien wat hun maandlasten worden zonder ingewikkelde berekeningen. Dat schept vertrouwen en versnelt de besluitvorming.",
            
            question3: "Welke functionaliteit heeft volgens jou de meeste verkopen opgeleverd?",
            answer3: "Zonder twijfel de geïntegreerde financieringscheck. Doordat klanten direct kunnen zien of ze in aanmerking komen voor financiering, is de drempel om een aankoop te overwegen aanzienlijk verlaagd. Dit heeft onze conversie met 35% verhoogd.",
            
            question4: "Wanneer dacht je: Oei, dit wordt écht goed?",
            answer4: "Toen we de eerste week live waren en ik 's avonds nog een verkoopaanvraag binnenkreeg via het platform. De klant had het hele proces doorlopen zonder vragen te stellen. Dat was voor mij het bewijs dat de website precies deed wat die moest doen.",
            
            question5: "Stel, je belt je toekomstige zelf over deze samenwerking. Wat zeg je dan?",
            answer5: "'Blijf luisteren naar wat zij adviseren.' Jullie kennis van online verkoopprocessen en gebruikerservaring heeft ons bedrijf naar een hoger niveau getild. Dat is goud waard in deze concurrerende markt.",
            
            author: "Thomas Fischer",
            role: "Eigenaar",
            project: "Verkoopondersteuning",
            image: "/img/testimonials/thomas-fischer.jpg"
        },
        
        sections: {
            showcase: {
                1: {
                    title: 'Showcase benaming',
                    description: 'Showcase uitleg komt hier te staan',
                    image: "https://images.unsplash.com/photo-1599202875854-23b7cd490ff4?q=80&w=2382&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
                },
                2: {
                    title: 'Showcase benaming',
                    description: 'Showcase uitleg komt hier te staan',
                    image: "https://images.unsplash.com/photo-1441015401724-70d16b783f5c?q=80&w=2940&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
                },
                3: {
                    title: 'Showcase benaming',
                    description: 'Showcase uitleg komt hier te staan',
                    image: "https://images.unsplash.com/photo-1511376777868-611b54f68947?q=80&w=2940&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
                },
            },
            bentoGrid: [
                {
                    title: "Verkoop",
                    heading: "Directe biedingen",
                    description: "Ontvang binnen enkele uren meerdere biedingen van geverifieerde autodealers op je te verkopen voertuig."
                },
                {
                    title: "Integraties",
                    heading: "Alles verbonden",
                    description: "Naadloze koppelingen met RDW, verzekeringsmaatschappijen en financiële dienstverleners.",
                    integrations: [
                        {
                            name: "RDW Connect",
                            icon: "https://upload.wikimedia.org/wikipedia/commons/thumb/9/94/Logo_RDW.svg/1200px-Logo_RDW.svg.png",
                        },
                        {
                            name: "AutoScout24",
                            icon: "https://upload.wikimedia.org/wikipedia/commons/thumb/7/73/AutoScout24_logo.svg/2560px-AutoScout24_logo.svg.png",
                        },
                        {
                            name: "BPM Calculator",
                            icon: "https://cdn-icons-png.flaticon.com/512/2344/2344156.png",
                        },
                        {
                            name: "Marktplaats",
                            icon: "https://upload.wikimedia.org/wikipedia/commons/thumb/e/e6/Marktplaats_logo.svg/1200px-Marktplaats_logo.svg.png",
                        },
                        {
                            name: "BOVAG",
                            icon: "https://upload.wikimedia.org/wikipedia/commons/thumb/7/72/BOVAG_logo.svg/1200px-BOVAG_logo.svg.png",
                        }
                    ]
                },
                {
                    title: "Veiligheid",
                    heading: "Veilige transacties",
                    description: "Beveiligde transacties en verificatieprocessen zorgen voor een betrouwbare ervaring voor kopers en verkopers."
                },
                {
                    title: "Prestaties",
                    heading: "Razendsnelle matching",
                    description: "Geavanceerd algoritme matcht auto's aan de juiste kopers voor een optimale prijs in minimale tijd."
                }
            ]
        }
    },
    
    { 
        meta: {
            id: 5, 
            name: "Knetterhard", 
            icon: 'speaker',
            href: "https://knetterhard.party",
            logo: "/img/projects/knetterhard/knetterhard-logo.svg",
            showInHeader: true,
            categoryIds: [8, 9],
            slug: 'knetterhard'
        },
        
        content: {
            title: "Knetterhard",
            subTitle: "Top kwaliteit geluid en licht",
            description: 'Website voor verhuur van speakers, met een overzichtelijk assortiment en eenvoudige huurprocessen.',
            longDescription: 'Knetterhard is een platform voor het huren van speakers, dat een breed assortiment biedt voor zowel zakelijke als persoonlijke evenementen. Gebruikers kunnen gemakkelijk speakers selecteren, huren en direct betalen via de website. Het platform is ontworpen met het oog op eenvoud en gemak, zodat het huren van audioapparatuur snel en zonder gedoe gebeurt. We hebben gekozen voor een gebruiksvriendelijke interface die klanten direct naar de juiste apparatuur leidt.',
            subDescription: "Ja, Knetterhard maakt dat mogelijk.",
            extraInfo: "Met Knetterhard kunnen gebruikers eenvoudig de juiste audioapparatuur huren voor elk type evenement. Het platform biedt een breed scala aan speakers en geluidsapparatuur die geschikt zijn voor zowel kleine als grote bijeenkomsten. Of je nu een huisfeest organiseert of een professioneel evenement, je kunt snel de apparatuur vinden die je nodig hebt en het direct online reserveren. Het proces is eenvoudig en intuïtief, zodat je je geen zorgen hoeft te maken over de technische details. Binnen enkele minuten kun je de apparatuur huren en verzekerd zijn van topkwaliteit geluid zonder gedoe.",
            metaDescription: 'Knetterhard is een gebruiksvriendelijk platform voor het huren van speakers en geluidsapparatuur voor elk type evenement.',
            hoverCta: "Zo losten we het op"
        },
        
        style: {
            projectColor: "knetterhard",
            mainColor: "#FA4716"
        },
        
        media: {
            image: "/img/projects/iMac_24_inch_zilver.webp", 
            sliderImage: "/img/projects/knetterhard/showcaseCard.webp",
            productsPageImage: '/img/projects/knetterhard/projectpageImage.webp',
            mockupImages: {
                mid: {
                    src: "https://www.apple.com/v/mac/mac-does-that/i/images/overview/hero/hero_imac__fkl0k65jazyq_xlarge_2x.png",
                    alt: "Visualisatie van het platform op desktop"
                },
                left: {
                    src: "https://www.apple.com/v/mac/mac-does-that/i/images/overview/hero/hero_macbook_pro__dxwubu2fr8ia_xlarge_2x.png",
                    alt: "Desktopweergave van het platform"
                },
                right: {
                    src: "https://www.apple.com/v/mac/mac-does-that/i/images/overview/hero/hero_macbook_air__og7y4ihieoa6_xlarge_2x.png",
                    alt: "Mobiele weergave van het platform"
                }
            }
        },
        
        // Add testimonial
        testimonial: {
            question1: "Wat was het grootste misverstand dat je vóór ons nog over 'een goede website' had?",
            answer1: "Sinds we met het Knetterhard platform werken, is onze verhuurafdeling veel efficiënter geworden. Klanten waarderen het gemak waarmee ze apparatuur kunnen reserveren.",
            
            question2: "Hoe heeft de samenwerking met ons jouw kijk op webdevelopment veranderd?",
            answer2: "Er is een wereld voor me opengegaan. Jullie hebben niet alleen een website voor ons gebouwd, maar een compleet systeem dat onze processen ondersteunt en verbetert.",
            
            question3: "Welke functie van het platform heeft je het meest verrast?",
            answer3: "De automatische beschikbaarheidsupdates voor de verhuurde apparatuur. Dit voorkomt dubbel boekingen en zorgt voor een soepele afhandeling.",
            
            question4: "Wanneer dacht je: Oei, dit wordt écht goed?",
            answer4: "Tijdens de eerste live demonstratie voor ons team. Iedereen was onder de indruk van hoe intuïtief en snel het platform werkte.",
            
            question5: "Stel, je belt je toekomstige zelf over deze samenwerking. Wat zeg je dan?",
            answer5: "'Je hebt een slimme zet gedaan. Deze samenwerking opent deuren naar nieuwe mogelijkheden en groei.'",
            
            author: "DJ Maxime",
            role: "Manager Verhuur",
            project: "Verhuurplatform",
            image: "/img/testimonials/knetterhard-logo.png"
        },
        
        sections: {
            showcase: {
                1: {
                    title: 'Showcase benaming',
                    description: 'Showcase uitleg komt hier te staan',
                    image: "https://images.unsplash.com/photo-1599202875854-23b7cd490ff4?q=80&w=2382&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
                },
                2: {
                    title: 'Showcase benaming',
                    description: 'Showcase uitleg komt hier te staan',
                    image: "https://images.unsplash.com/photo-1441015401724-70d16b783f5c?q=80&w=2940&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
                },
                3: {
                    title: 'Showcase benaming',
                    description: 'Showcase uitleg komt hier te staan',
                    image: "https://images.unsplash.com/photo-1511376777868-611b54f68947?q=80&w=2940&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
                },
            },
            bentoGrid: [
                {
                    title: "Verhuur",
                    heading: "Directe beschikbaarheid",
                    description: "Bekijk direct welke speakers beschikbaar zijn en reserveer ze voor de dagen die jij nodig hebt."
                },
                {
                    title: "Integraties",
                    heading: "Seamless betalingen",
                    description: "Geïntegreerd met alle populaire betaalmethoden en evenementplanners voor een naadloze ervaring.",
                    integrations: [
                        {
                            name: "JBL Connect",
                            icon: "https://www.freepnglogos.com/uploads/jbl-logo-png/jbl-logo-png-jbl-png-transparent-logo-1.png",
                        },
                        {
                            name: "Pioneer DJ",
                            icon: "https://logodownload.org/wp-content/uploads/2020/12/pioneer-dj-logo-0.png",
                        },
                        {
                            name: "SoundCloud",
                            icon: "https://upload.wikimedia.org/wikipedia/commons/thumb/a/a2/Soundcloud_logo.svg/2560px-Soundcloud_logo.svg.png",
                        },
                        {
                            name: "Eventplanner",
                            icon: "https://cdn-icons-png.flaticon.com/512/3652/3652191.png",
                        },
                        {
                            name: "Mollie Payments",
                            icon: "https://upload.wikimedia.org/wikipedia/commons/thumb/e/e5/Mollie_logo.svg/1200px-Mollie_logo.svg.png",
                        }
                    ]
                },
                {
                    title: "Veiligheid",
                    heading: "Bescherming voorop",
                    description: "Persoonlijke gegevens beschermd met end-to-end encryptie en strikte toegangscontrole voor gebruikersdata."
                },
                {
                    title: "Gebruikservaring",
                    heading: "Ontworpen voor eenvoud",
                    description: "Intuïtieve interface die zowel op desktop als mobiele apparaten een soepele gebruikerservaring biedt."
                }
            ]
        }
    },
    
    { 
        meta: {
            id: 6, 
            name: "TEZ Tennis/Padel", 
            icon: 'racquet',
            href: "https://www.tezenschede.nl/",
            logo: "/img/projects/tez/tez-logo.svg",
            showInHeader: true,
            categoryIds: [5, 8],
            slug: 'tez-tennis-padel'
        },
        
        content: {
            title: "TEZ Tennis/Padel",
            subTitle: "Tennis en Padel vereniging",
            description: 'Platform voor tennis- en padelvereniging, waar leden lesroosters, evenementen en competities kunnen inzien en zich aanmelden.',
            longDescription: 'TEZ Tennis/Padel is een platform voor tennis- en padelverenigingen waarin leden eenvoudig toegang hebben tot lesroosters, evenementen en competities. Leden kunnen zich snel aanmelden voor activiteiten en hun voortgang volgen. Dit project is ontwikkeld in samenwerking met de vereniging om de clubadministratie te vereenvoudigen en tegelijkertijd een betere gebruikerservaring te bieden voor de leden. Het platform zorgt ervoor dat alles wat een lid nodig heeft voor een sportieve ervaring, binnen handbereik is.',
            subDescription: "Ja, TEZ regelt dat.",
            extraInfo: "TEZ Tennis/Padel biedt leden van de vereniging een gebruiksvriendelijke manier om toegang te krijgen tot alles wat ze nodig hebben om optimaal van hun sportervaring te genieten. Het platform biedt een overzicht van lesroosters, waar leden eenvoudig de geplande trainingen en wedstrijden kunnen inzien. Daarnaast kunnen leden zich snel aanmelden voor evenementen en competities. Dit maakt het gemakkelijker om deel te nemen aan activiteiten en zorgt ervoor dat niemand een belangrijke gebeurtenis mist. De integratie van voortgangsrapportages helpt spelers ook hun prestaties bij te houden en zich verder te ontwikkelen in de sport.",
            metaDescription: 'TEZ Tennis/Padel is een platform dat tennis- en padelverenigingen helpt bij het beheren van lesroosters, evenementen en competities.',
            hoverCta: "Zo brengen we verbinding"
        },
        
        style: {
            projectColor: "tez",
            mainColor: "#B42423"
        },
        
        media: {
            image: "/img/projects/iMac_24_inch_zilver.webp", 
            sliderImage: "/img/projects/tez/showcaseCard.webp",
            productsPageImage: '/img/projects/tez/projectpageImage.webp',
            mockupImages: {
                mid: {
                    src: "https://www.apple.com/v/mac/mac-does-that/i/images/overview/hero/hero_imac__fkl0k65jazyq_xlarge_2x.png",
                    alt: "Visualisatie van het platform op desktop"
                },
                left: {
                    src: "https://www.apple.com/v/mac/mac-does-that/i/images/overview/hero/hero_macbook_pro__dxwubu2fr8ia_xlarge_2x.png",
                    alt: "Desktopweergave van het platform"
                },
                right: {
                    src: "https://www.apple.com/v/mac/mac-does-that/i/images/overview/hero/hero_macbook_air__og7y4ihieoa6_xlarge_2x.png",
                    alt: "Mobiele weergave van het platform"
                }
            }
        },
        
        // Add testimonial
        testimonial: {
            question1: "Wat was het grootste misverstand dat je vóór ons nog over 'een goede website' had?",
            answer1: "Ik dacht dat een vereniging website vooral veel informatie en weinig interactie moest hebben. Jullie hebben ons laten zien hoe belangrijk het is dat leden actief betrokken worden en gemakkelijk kunnen communiceren.",
            
            question2: "Hoe heeft de nieuwe website de betrokkenheid van leden veranderd?",
            answer2: "De impact is enorm. Leden gebruiken de site nu dagelijks om hun trainingen en wedstrijden te plannen. Ook de communicatie met trainers gaat veel soepeler. We krijgen regelmatig positieve feedback over hoe gebruiksvriendelijk alles is.",
            
            question3: "Welke functie van de website wordt het meest gewaardeerd door de leden?",
            answer3: "Zonder twijfel de baanreserveringsfunctie. Leden vinden het geweldig dat ze op elk moment van de dag hun trainingen kunnen inplannen en dat ze direct een bevestiging ontvangen.",
            
            question4: "Wanneer dacht je: Oei, dit wordt écht goed?",
            answer4: "Tijdens een ledenvergadering waar we de nieuwe website presenteerden. De enthousiaste reacties en het directe gebruik van de site door onze leden gaven me het vertrouwen dat we de juiste keuze hadden gemaakt.",
            
            question5: "Stel, je belt je toekomstige zelf over deze samenwerking. Wat zeg je dan?",
            answer5: "'Dit is pas het begin. Blijf innoveren en luisteren naar je leden. Jullie hebben nu een sterke basis, bouw daarop voort.'",
            
            author: "Joost van der Meer",
            role: "Voorzitter",
            project: "Clubmanagement Systeem",
            image: "/img/testimonials/joost-van-der-meer.jpg"
        },
        
        sections: {
            showcase: {
                1: {
                    title: 'Showcase benaming',
                    description: 'Showcase uitleg komt hier te staan',
                    image: "https://images.unsplash.com/photo-1599202875854-23b7cd490ff4?q=80&w=2382&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
                },
                2: {
                    title: 'Showcase benaming',
                    description: 'Showcase uitleg komt hier te staan',
                    image: "https://images.unsplash.com/photo-1441015401724-70d16b783f5c?q=80&w=2940&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
                },
                3: {
                    title: 'Showcase benaming',
                    description: 'Showcase uitleg komt hier te staan',
                    image: "https://images.unsplash.com/photo-1511376777868-611b54f68947?q=80&w=2940&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
                },
            },
            bentoGrid: [
                {
                    title: "Planning",
                    heading: "Baanreservering",
                    description: "Reserveer eenvoudig banen voor tennis of padel en plan trainingen met jouw favoriete trainer."
                },
                {
                    title: "Integraties",
                    heading: "Alles verbonden",
                    description: "Koppeling met jouw agenda, betalingssystemen en sociale media om jouw sportervaring te delen.",
                    integrations: [
                        {
                            name: "KNLTB App",
                            icon: "https://upload.wikimedia.org/wikipedia/commons/thumb/3/32/KNLTB_logo.svg/1200px-KNLTB_logo.svg.png",
                        },
                        {
                            name: "ClubCollect",
                            icon: "https://cdn-icons-png.flaticon.com/512/5261/5261919.png",
                        },
                        {
                            name: "PlayTomic",
                            icon: "https://play-lh.googleusercontent.com/JYW7QAdWJCuWwcOKQMaCiwXw7nm4aznZ7YPJbZJQ3qBhv8uTYGp1OdULT4y5gQUTZsE",
                        },
                        {
                            name: "Tikkie",
                            icon: "https://upload.wikimedia.org/wikipedia/commons/thumb/8/85/Tikkie-logo.svg/1200px-Tikkie-logo.svg.png",
                        },
                        {
                            name: "Strava",
                            icon: "https://upload.wikimedia.org/wikipedia/commons/thumb/6/6b/Strava_logo.svg/2560px-Strava_logo.svg.png",
                        }
                    ]
                },
                {
                    title: "Competitie",
                    heading: "Volg je prestaties",
                    description: "Houd je competitieresultaten bij en verbeter je ranking binnen de club en nationale competities."
                },
                {
                    title: "Community",
                    heading: "Ontmoet spelers",
                    description: "Vind spelers van jouw niveau en organiseer friendly matches of neem deel aan clubevenementen."
                }
            ]
        }
    },
    
    { 
        meta: {
            id: 7, 
            name: "MHC Almelo", 
            icon: 'hockey-stick',
            href: "https://www.mhcalmelo.nl",
            logo: "/img/projects/mhc/mhc-logo.svg",
            showInHeader: false,
            categoryIds: [5, 8],
            slug: 'mhc-almelo',
            metaDescription: 'MHC Almelo biedt een compleet hockeyclub management systeem voor leden, trainers, coaches en bestuur.'
        },
        content: {
            title: "MHC Almelo",
            subTitle: "Hockey voor iedereen",
            description: 'Platform voor hockeyclub Almelo met team-management, wedstrijdschema\'s en ledenadministratie.',
            longDescription: 'MHC Almelo is een digitaal platform ontworpen voor de Mixed Hockey Club Almelo, dat zowel leden als bestuur helpt bij het organiseren van teamactiviteiten, wedstrijden en trainingen. Het platform stroomlijnt communicatie, maakt inschrijvingen eenvoudiger en biedt een centrale plek voor alle clubinformatie.',
            subDescription: "Ja, MHC Almelo verbindt ons allemaal.",
            extraInfo: "Het MHC Almelo platform brengt de hele hockeygemeenschap samen met functies zoals automatische teamindelingen, wedstrijdnotificaties, trainingsschema's en een ledenportaal. Het systeem maakt clubadministratie efficiënter en verbetert de communicatie tussen leden, coaches en bestuur.",
            hoverCta: "Flexibel gebouwd"
        },
        style: {
            projectColor: "mhc",
            mainColor: "#007934"
        },
        media: {
            image: "/img/projects/iMac_24_inch_zilver.webp",
            sliderImage: "/img/projects/mhc/showcaseCard.webp",
            productsPageImage: '/img/projects/mhc/projectpageImage.webp',
            mockupImages: {
                mid: { src: "https://www.apple.com/v/mac/mac-does-that/i/images/overview/hero/hero_imac__fkl0k65jazyq_xlarge_2x.png", alt: "Visualisatie van het platform op desktop" },
                left: { src: "https://www.apple.com/v/mac/mac-does-that/i/images/overview/hero/hero_macbook_pro__dxwubu2fr8ia_xlarge_2x.png", alt: "Desktopweergave van het platform" },
                right: { src: "https://www.apple.com/v/mac/mac-does-that/i/images/overview/hero/hero_macbook_air__og7y4ihieoa6_xlarge_2x.png", alt: "Mobiele weergave van het platform" }
            }
        },
        testimonial: {
            question1: "Wat was het grootste misverstand dat je vóór ons nog over 'een goede website' had?",
            answer1: "Het grootste misverstand was dat een goede website veel geld moest kosten en enorm complex moest zijn. Jullie hebben ons laten zien dat een duidelijke structuur en gebruiksvriendelijkheid veel belangrijker zijn.",
            
            question2: "Hoe heeft de nieuwe website de communicatie binnen de club verbeterd?",
            answer2: "De website fungeert nu als centraal punt voor alle communicatie. Leden, trainers en het bestuur kunnen gemakkelijk informatie delen en vinden, wat leidt tot minder misverstanden en een betere samenwerking.",
            
            question3: "Welke functie van de website heeft volgens jou de meeste tijdswinst opgeleverd?",
            answer3: "Zeker de automatische wedstrijdplanning. Dit bespaart ons uren handmatig werk per week en zorgt ervoor dat iedereen altijd op de hoogte is van de laatste wijzigingen.",
            
            question4: "Wanneer dacht je: Oei, dit wordt écht goed?",
            answer4: "Tijdens de eerste test met echte gebruikers. Hun positieve reacties en het feit dat ze geen enkele uitleg nodig hadden, gaf me het vertrouwen dat we iets bijzonders hadden gecreëerd.",
            
            question5: "Stel, je belt je toekomstige zelf over deze samenwerking. Wat zeg je dan?",
            answer5: "'Je hebt een slimme zet gedaan. Deze samenwerking opent deuren naar nieuwe mogelijkheden en groei.'",
            
            author: "Martijn Heuvink",
            role: "Voorzitter",
            project: "Club Management Systeem",
            image: "/img/testimonials/martijn-heuvink.jpg"
        },
        sections: {
            showcase: {
                1: { title: 'Showcase benaming', description: 'Showcase uitleg komt hier te staan', image: "https://images.unsplash.com/photo-1552234994-66ba234fd567?auto=format&fit=crop&q=80&w=2940&ixlib=rb-4.0.3" },
                2: { title: 'Showcase benaming', description: 'Showcase uitleg komt hier te staan', image: "https://images.unsplash.com/photo-1591491709011-4782f4e75228?auto=format&fit=crop&q=80&w=2940&ixlib=rb-4.0.3" },
                3: { title: 'Showcase benaming', description: 'Showcase uitleg komt hier te staan', image: "https://images.unsplash.com/photo-1620712943543-bcc4688e7485?auto=format&fit=crop&q=80&w=2940&ixlib=rb-4.0.3" },
            },
            bentoGrid: [
                { title: "Teams", heading: "Teambeheer", description: "Organiseer teamindelingen, beheer aanwezigheid en communiceer direct met teamleden." },
                { title: "Wedstrijden", heading: "Wedstrijdschema's", description: "Automatische wedstrijdplanning en -notificaties voor spelers, coaches en ouders." },
                { title: "Ledenadministratie", heading: "Centraal ledenbeheer", description: "Beheer alle ledengegevens, contributiebetalingen en verenigingscommunicatie op één plek." },
                { title: "Training", heading: "Trainingsplatform", description: "Deel trainingsschema's, oefeningen en feedback met teams en individuele spelers." }
            ]
        }
    },

    { 
        meta: {
            id: 8, 
            name: "UCaaS", 
            icon: 'phone-office',
            href: "https://www.ucaas.nl",
            logo: "/img/projects/ucaas/ucaas-logo.svg",
            showInHeader: false,
            categoryIds: [3, 4],
            slug: 'ucaas',
            metaDescription: 'UCaaS levert geïntegreerde communicatieoplossingen voor bedrijven die op zoek zijn naar een flexibel en schaalbaar communicatieplatform.'
        },
        content: {
            title: "UCaaS",
            subTitle: "Communicatie in de cloud",
            description: 'Unified Communications as a Service platform dat telefonie, videogesprekken, chat en e-mail integreert in één gebruiksvriendelijke oplossing.',
            longDescription: 'UCaaS (Unified Communications as a Service) is een cloudgebaseerd platform dat verschillende communicatiekanalen samenbrengt in één geïntegreerde oplossing. Het systeem maakt naadloze overgangen tussen telefonie, videogesprekken, chatberichten en e-mail mogelijk, waardoor teams efficiënter kunnen samenwerken, ongeacht hun locatie.',
            subDescription: "Ja, UCaaS verbindt alles.",
            extraInfo: "Het UCaaS-platform biedt geavanceerde communicatiefunctionaliteiten zoals auto-attendant, voicemail-naar-e-mail, presence-indicatie, screen sharing en gedetailleerde rapportages. De dienst is volledig schaalbaar en kan worden aangepast aan de behoeften van zowel kleine bedrijven als grote ondernemingen.",
            hoverCta: "Ga mee achter de schermen",
        },
        style: {
            projectColor: "ucaas",
            mainColor: "#2C85EB"
        },
        media: {
            image: "/img/projects/iMac_24_inch_zilver.webp", 
            sliderImage: "/img/projects/ucaas/showcaseCard.webp",
            productsPageImage: '/img/projects/ucaas/projectpageImage.webp',
            mockupImages: {
                mid: { src: "https://www.apple.com/v/mac/mac-does-that/i/images/overview/hero/hero_imac__fkl0k65jazyq_xlarge_2x.png", alt: "Visualisatie van het platform op desktop" },
                left: { src: "https://www.apple.com/v/mac/mac-does-that/i/images/overview/hero/hero_macbook_pro__dxwubu2fr8ia_xlarge_2x.png", alt: "Desktopweergave van het platform" },
                right: { src: "https://www.apple.com/v/mac/mac-does-that/i/images/overview/hero/hero_macbook_air__og7y4ihieoa6_xlarge_2x.png", alt: "Mobiele weergave van het platform" }
            }
        },
        testimonial: {
            question1: "Wat was het grootste misverstand dat je vóór ons nog over 'een goede website' had?",
            answer1: "Ik dacht dat een communicatieplatform vooral veel functies moest hebben, maar jullie hebben aangetoond dat gebruiksgemak en integratie de sleutel zijn.",
            
            question2: "Hoe heeft UCaaS de manier waarop je bedrijf communiceert veranderd?",
            answer2: "UCaaS heeft onze communicatie gestroomlijnd. We kunnen nu gemakkelijk schakelen tussen verschillende communicatiemiddelen zonder dat dit ten koste gaat van de kwaliteit.",
            
            question3: "Welke functie van UCaaS vind je het meest waardevol?",
            answer3: "De mogelijkheid om alles vanuit één platform te beheren. Of het nu gaat om telefonie, video of chat, alles is geïntegreerd en werkt naadloos samen.",
            
            question4: "Wanneer dacht je: Oei, dit wordt écht goed?",
            answer4: "Tijdens de implementatie, toen we merkten hoe snel en eenvoudig alles te integreren was met onze bestaande systemen.",
            
            question5: "Stel, je belt je toekomstige zelf over deze samenwerking. Wat zeg je dan?",
            answer5: "'Dit is een investering in de toekomst van je bedrijf. Blijf innoveren en gebruik maken van de nieuwste technologieën.'",
            
            author: "Karin Vissers",
            role: "IT Manager",
            project: "Communicatieplatform",
            image: "/img/testimonials/karin-vissers.jpg"
        },
        sections: {
            showcase: {
                1: { title: 'Showcase benaming', description: 'Showcase uitleg komt hier te staan', image: "https://images.unsplash.com/photo-1600880292203-757bb62b4baf?auto=format&fit=crop&q=80&w=2940&ixlib=rb-4.0.3" },
                2: { title: 'Showcase benaming', description: 'Showcase uitleg komt hier te staan', image: "https://images.unsplash.com/photo-1587614382346-4ec70e388b28?auto=format&fit=crop&q=80&w=2940&ixlib=rb-4.0.3" },
                3: { title: 'Showcase benaming', description: 'Showcase uitleg komt hier te staan', image: "https://images.unsplash.com/photo-1573164713988-8665fc963095?auto=format&fit=crop&q=80&w=2940&ixlib=rb-4.0.3" },
            },
            bentoGrid: [
                { title: "Communicatie", heading: "Alles geïntegreerd", description: "Telefonie, video, chat en e-mail in één platform voor naadloze communicatie." },
                { title: "Flexibiliteit", heading: "Werk overal", description: "Toegang tot alle communicatiemiddelen vanaf elk apparaat, waar je ook bent." },
                { title: "Rapportage", heading: "Inzicht in gebruik", description: "Gedetailleerde rapportages over communicatiepatronen en gebruiksstatistieken." },
                { title: "Integraties", heading: "Verbind met alles", description: "Naadloze integratie met CRM, ERP en andere bedrijfssystemen voor optimale workflows." }
            ]
        }
    },

    { 
        meta: {
            id: 9, 
            name: "Preventiv", 
            icon: 'heart-pulse',
            href: "https://www.preventiv.nl",
            logo: "/img/projects/preventiv/preventiv-logo.svg",
            showInHeader: false,
            categoryIds: [1, 2],
            slug: 'preventiv',
            metaDescription: 'Preventiv is een innovatief gezondheidsplatform dat preventieve zorg toegankelijk maakt via gepersonaliseerde gezondheidsscreening en coaching.'
        },
        content: {
            title: "Preventiv",
            subTitle: "Gezondheid voorop",
            description: 'Preventieve gezondheidszorg platform met persoonlijke gezondheidsmonitoring, coaching en geautomatiseerde screenings.',
            longDescription: 'Preventiv is een innovatief platform voor preventieve gezondheidszorg dat individuen helpt hun gezondheid te monitoren en te verbeteren voordat problemen ontstaan. Het biedt persoonlijke gezondheidsscreenings, coaching en analyses om gebruikers inzicht te geven in hun gezondheid en concrete stappen te nemen voor een gezondere levensstijl.',
            subDescription: "Ja, Preventiv houdt je gezond.",
            extraInfo: "Het Preventiv platform combineert geavanceerde gezondheidsmetingen met persoonlijke coaching en AI-analyses om gebruikers een volledig beeld te geven van hun gezondheid. Het systeem identificeert gezondheidsrisico's vroegtijdig en biedt gepersonaliseerde interventies om deze te verminderen.",
            hoverCta: "Hier komt alles samen"
        },
        style: {
            projectColor: "preventiv",
            mainColor: "#44C8B1"
        },
        media: {
            image: "/img/projects/iMac_24_inch_zilver.webp", 
            sliderImage: "/img/projects/preventiv/showcaseCard.webp",
            productsPageImage: '/img/projects/preventiv/projectpageImage.webp',
            mockupImages: {
                mid: { src: "https://www.apple.com/v/mac/mac-does-that/i/images/overview/hero/hero_imac__fkl0k65jazyq_xlarge_2x.png", alt: "Visualisatie van het platform op desktop" },
                left: { src: "https://www.apple.com/v/mac/mac-does-that/i/images/overview/hero/hero_macbook_pro__dxwubu2fr8ia_xlarge_2x.png", alt: "Desktopweergave van het platform" },
                right: { src: "https://www.apple.com/v/mac/mac-does-that/i/images/overview/hero/hero_macbook_air__og7y4ihieoa6_xlarge_2x.png", alt: "Mobiele weergave van het platform" }
            }
        },
        testimonial: {
            question1: "Wat was het grootste misverstand dat je vóór ons nog over 'een goede website' had?",
            answer1: "Ik dacht dat een gezondheidsplatform vooral veel medische termen en ingewikkelde vragen moest bevatten. Jullie hebben het simpel gehouden, waardoor het voor iedereen begrijpelijk is.",
            
            question2: "Hoe heeft Preventiv jouw kijk op gezondheidszorg veranderd?",
            answer2: "Preventiv heeft me doen inzien hoe belangrijk preventie is. Vroeger dacht ik dat gezondheidszorg pas begon als je ziek was. Nu begrijp ik dat je proactief aan je gezondheid kunt werken.",
            
            question3: "Welke functie van Preventiv gebruik je het meest?",
            answer3: "Zeker de gezondheidsmonitor. Het is geruststellend om regelmatig een update te krijgen over mijn vitale functies en te zien waar ik eventueel moet bijsturen.",
            
            question4: "Wanneer dacht je: Oei, dit wordt écht goed?",
            answer4: "Tijdens het eerste gesprek met mijn persoonlijke coach via het platform. De combinatie van technologie en persoonlijke aandacht werkt echt.",
            
            question5: "Stel, je belt je toekomstige zelf over deze samenwerking. Wat zeg je dan?",
            answer5: "'Je hebt een slimme zet gedaan. Deze samenwerking opent deuren naar nieuwe mogelijkheden en groei.'",
            
            author: "Dr. Sophie Bergman",
            role: "Bedrijfsarts",
            project: "Gezondheidsmonitoring",
            image: "/img/testimonials/dr-sophie-bergman.jpg"
        },
        sections: {
            showcase: {
                1: { title: 'Showcase benaming', description: 'Showcase uitleg komt hier te staan', image: "https://images.unsplash.com/photo-1576091160550-2173dba999ef?auto=format&fit=crop&q=80&w=2940&ixlib=rb-4.0.3" },
                2: { title: 'Showcase benaming', description: 'Showcase uitleg komt hier te staan', image: "https://images.unsplash.com/photo-1530026186672-2cd00ffc50fe?auto=format&fit=crop&q=80&w=2940&ixlib=rb-4.0.3" },
                3: { title: 'Showcase benaming', description: 'Showcase uitleg komt hier te staan', image: "https://images.unsplash.com/photo-1506126613408-eca07ce68773?auto=format&fit=crop&q=80&w=2940&ixlib=rb-4.0.3" },
            },
            bentoGrid: [
                { title: "Monitoring", heading: "Gezondheidsdata", description: "Continue monitoring van vitale gezondheidsparameters met persoonlijke inzichten." },
                { title: "Coaching", heading: "Persoonlijke begeleiding", description: "Toegang tot gezondheidsexperts voor op maat gemaakte coaching en adviezen." },
                { title: "Preventie", heading: "Vroege interventie", description: "Identificatie van gezondheidsrisico's voordat ze tot problemen leiden en concrete preventieve maatregelen." },
                { title: "Rapportage", heading: "Gezondheidsanalyses", description: "Gedetailleerde rapportages en trendanalyses van je gezondheidsdata voor optimaal inzicht." }
            ]
        }
    },

    { 
        meta: {
            id: 10, 
            name: "Vinylio", 
            icon: 'record-vinyl',
            href: "https://www.vinylio.nl",
            logo: "/img/projects/vinylio/vinylio-logo.svg",
            showInHeader: false,
            categoryIds: [5, 7],
            slug: 'vinylio',
            metaDescription: 'Vinylio is hét platform voor vinylliefhebbers om hun collectie te beheren, zeldzame platen te ontdekken en met andere verzamelaars te connecten.'
        },
        content: {
            title: "Vinylio",
            subTitle: "Het beste vinylplatform",
            description: 'Platform voor vinylverzamelaars om hun collectie te beheren, zeldzame platen te vinden en met andere verzamelaars in contact te komen.',
            longDescription: 'Vinylio is een online platform dat vinylverzamelaars helpt hun collectie te digitaliseren, te organiseren en uit te breiden. Het biedt een gedetailleerd catalogiseringssysteem, mogelijkheden om te handelen met andere verzamelaars, en geavanceerde zoekfuncties om zeldzame platen te vinden. De community-aspecten zorgen voor een rijk netwerk van muziekliefhebbers.',
            subDescription: "Ja, Vinylio draait voor je.",
            extraInfo: "Vinylio biedt verzamelaars gedetailleerde informatie over persingen, staat van platen en marktwaarde. Gebruikers kunnen hun collectie scannen, waarderingen bijhouden en statistieken bekijken. De handelsmarkt verbindt kopers en verkopers direct, terwijl evenementen en forums de community versterken.",
            hoverCta: "Slimme aanpak bekijken"
        },
        style: {
            projectColor: "vinylio",
            mainColor: "#BB2649"
        },
        media: {
            image: "/img/projects/iMac_24_inch_zilver.webp", 
            sliderImage: "/img/projects/vinylio/showcaseCard.webp",
            productsPageImage: '/img/projects/vinylio/projectpageImage.webp',
            mockupImages: {
                mid: { src: "https://www.apple.com/v/mac/mac-does-that/i/images/overview/hero/hero_imac__fkl0k65jazyq_xlarge_2x.png", alt: "Visualisatie van het platform op desktop" },
                left: { src: "https://www.apple.com/v/mac/mac-does-that/i/images/overview/hero/hero_macbook_pro__dxwubu2fr8ia_xlarge_2x.png", alt: "Desktopweergave van het platform" },
                right: { src: "https://www.apple.com/v/mac/mac-does-that/i/images/overview/hero/hero_macbook_air__og7y4ihieoa6_xlarge_2x.png", alt: "Mobiele weergave van het platform" }
            }
        },
        // Fix for Vinylio testimonial
        testimonial: {
            question1: "Wat was het grootste misverstand dat je vóór ons nog over 'een goede website' had?",
            answer1: "Ik dacht altijd dat een platform voor vinylverzamelaars vooral een digitale catalogus moest zijn. Jullie hebben me laten zien dat het ook draait om community en interactie tussen verzamelaars.",
            
            question2: "Hoe heeft Vinylio jouw ervaring als verzamelaar verbeterd?",
            answer2: "Vinylio heeft het veel gemakkelijker gemaakt om in contact te komen met andere verzamelaars en om zeldzame platen te vinden. De waarderingsfunctie helpt me ook om de waarde van mijn collectie in de gaten te houden.",
            
            question3: "Welke functie van Vinylio gebruik je het meest?",
            answer3: "Zeker de marktplaatsfunctie. Het is geweldig om direct te kunnen handelen met andere verzamelaars zonder tussenpersonen.",
            
            question4: "Wanneer dacht je: Oei, dit wordt écht goed?",
            answer4: "Toen ik voor het eerst een zeldzame plaat vond die ik al jaren zocht, aangeboden zag worden door een andere verzamelaar op Vinylio. Het voelde alsof het universum samenzweerde.",
            
            question5: "Stel, je belt je toekomstige zelf over deze samenwerking. Wat zeg je dan?",
            answer5: "'Blijf trouw aan je passie en laat je niet afleiden door kortetermijnsuccessen. Dit platform heeft de potentie om de verzamelwereld te veranderen.'",
            
            author: "Vincent Huisman",
            role: "Verzamelaar & Winkeleigenaar",
            project: "Verzamelplatform",
            image: "/img/testimonials/vincent-huisman.jpg"
        },
        
        sections: {
            showcase: {
                1: {
                    title: 'Showcase benaming',
                    description: 'Showcase uitleg komt hier te staan',
                    image: "https://images.unsplash.com/photo-1599202875854-23b7cd490ff4?q=80&w=2382&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
                },
                2: {
                    title: 'Showcase benaming',
                    description: 'Showcase uitleg komt hier te staan',
                    image: "https://images.unsplash.com/photo-1441015401724-70d16b783f5c?q=80&w=2940&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
                },
                3: {
                    title: 'Showcase benaming',
                    description: 'Showcase uitleg komt hier te staan',
                    image: "https://images.unsplash.com/photo-1511376777868-611b54f68947?q=80&w=2940&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
                },
            },
            bentoGrid: [
                {
                    title: "Voorraadbeheer",
                    heading: "Real-time inzicht",
                    description: "Actueel inzicht in voorraadniveaus, automatische voorraadwaarschuwingen en voorspellende analyses."
                },
                {
                    title: "Orderverwerking",
                    heading: "Gestroomlijnde processen",
                    description: "Automatische orderverzameling, pakbonnen en verzendlabels voor snelle en foutloze afhandeling."
                },
                {
                    title: "Integraties",
                    heading: "Verbonden platforms",
                    description: "Naadloze koppelingen met webshops, betaalsystemen en vervoerders voor een complete oplossing."
                },
                {
                    title: "Analyses",
                    heading: "Datagedreven beslissingen",
                    description: "Uitgebreide rapportages en dashboard met KPI's voor voorraadbeheer en logistieke prestaties."
                }
            ]
        }
    },

    { 
        meta: {
            id: 14, 
            name: "Indexa", 
            icon: 'chart-line',
            href: "https://www.indexa.nl",
            logo: "/img/projects/indexa/indexa-logo.svg",
            showInHeader: false,
            categoryIds: [2, 3],
            slug: 'indexa',
            metaDescription: 'Indexa is een geavanceerd financieel platform voor beleggers met realtime marktdata, portfolio-analyse en persoonlijke investeringsstrategieën.'
        },
        content: {
            title: "Indexa",
            subTitle: "Microsoft Word intergratie",
            description: 'Financieel platform voor beleggers en investeerders met realtime marktdata, portfolio-analyses en gepersonaliseerde investeringsadviezen.',
            longDescription: 'Indexa is een geavanceerd financieel platform dat beleggers helpt betere beslissingen te nemen met realtime marktdata, diepgaande analyses en gepersonaliseerde adviesmodellen. Het platform biedt inzicht in markttrends, helpt bij het samenstellen van gediversifieerde portfolio\'s en houdt automatisch prestaties bij.',
            subDescription: "Ja, Indexa analyseert alles.",
            extraInfo: "Indexa combineert geavanceerde financiële algoritmes met gebruiksvriendelijke interfaces om complexe marktdata toegankelijk te maken voor beleggers. Het platform ondersteunt verschillende beleggingsstrategieën en biedt geautomatiseerde rebalancing en belastingoptimalisatie.",
            hoverCta: "Hoe alles samenkomt in deze oplossing"
        },
        style: {
            projectColor: "indexa",
            mainColor: "#27AE60"
        },
        media: {
            image: "/img/projects/iMac_24_inch_zilver.webp", 
            sliderImage: "/img/projects/indexa/showcaseCard.webp",
            productsPageImage: '/img/projects/indexa/projectpageImage.webp',
            mockupImages: {
                mid: { src: "https://www.apple.com/v/mac/mac-does-that/i/images/overview/hero/hero_imac__fkl0k65jazyq_xlarge_2x.png", alt: "Visualisatie van het platform op desktop" },
                left: { src: "https://www.apple.com/v/mac/mac-does-that/i/images/overview/hero/hero_macbook_pro__dxwubu2fr8ia_xlarge_2x.png", alt: "Desktopweergave van het platform" },
                right: { src: "https://www.apple.com/v/mac/mac-does-that/i/images/overview/hero/hero_macbook_air__og7y4ihieoa6_xlarge_2x.png", alt: "Mobiele weergave van het platform" }
            }
        },
        // For testimonials with only 'quote' format, update them to the full Q&A format
        testimonial: {
            question1: "Wat was het grootste misverstand dat je vóór ons nog over 'een goede website' had?",
            answer1: "Ik dacht dat financiële data alleen door professionals begrepen kon worden. Jullie platform maakt complexe analyses toegankelijk voor iedereen.",
            
            question2: "Hoe heeft Indexa jouw werkwijze als financieel adviseur veranderd?",
            answer2: "Indexa stelt me in staat om complexe marktanalyses sneller uit te voeren en visueel te presenteren aan klanten, wat leidt tot betere besluitvorming en meer vertrouwen.",
            
            question3: "Welke functie van het platform heeft je het meest verrast?",
            answer3: "De geautomatiseerde portfolio-rebalancing functie. Het bespaart enorm veel tijd en vermindert menselijke fouten in het adviesproces.",
            
            question4: "Wanneer dacht je: Oei, dit wordt écht goed?",
            answer4: "Tijdens een klantpresentatie toen ik realtime marktdata kon tonen en direct scenario-analyses kon uitvoeren. De klant was onder de indruk en tekende direct.",
            
            question5: "Stel, je belt je toekomstige zelf over deze samenwerking. Wat zeg je dan?",
            answer5: "'Blijf innoveren met dit platform. Het onderscheidt je van concurrenten en stelt je in staat om betere service te leveren aan je klanten.'",
            
            author: "Laura Vermeer",
            role: "Financieel Adviseur",
            project: "Beleggingsplatform",
            image: "/img/testimonials/laura-vermeer.jpg"
        },
        sections: {
            showcase: {
                1: { title: 'Showcase benaming', description: 'Showcase uitleg komt hier te staan', image: "https://images.unsplash.com/photo-1535320903710-d993d3d77d29?auto=format&fit=crop&q=80&w=2940&ixlib=rb-4.0.3" },
                2: { title: 'Showcase benaming', description: 'Showcase uitleg komt hier te staan', image: "https://images.unsplash.com/photo-1569025690938-a00729c9e1f9?auto=format&fit=crop&q=80&w=2940&ixlib=rb-4.0.3" },
                3: { title: 'Showcase benaming', description: 'Showcase uitleg komt hier te staan', image: "https://images.unsplash.com/photo-1642543348745-03d1a451acef?auto=format&fit=crop&q=80&w=2940&ixlib=rb-4.0.3" },
            },
            bentoGrid: [
                { title: "Marktdata", heading: "Real-time inzichten", description: "Live marktgegevens, historische trends en geavanceerde technische analyses voor beter geïnformeerde beslissingen." },
                { title: "Portfolio", heading: "Holistische overzichten", description: "Volledige portfolio-analyse met prestatiemetingen, risico-evaluatie en diversificatieadviezen." },
                { title: "Strategie", heading: "Persoonlijke adviezen", description: "Op maat gemaakte beleggingsstrategieën op basis van je risicoprofiel, doelen en tijdshorizon." },
                { title: "Automatisering", heading: "Slimme tools", description: "Geautomatiseerde portfolio-rebalancing, dividend-reinvestering en belastingoptimalisatie." }
            ]
        }
    },
    
    { 
        meta: {
            id: 15, 
            name: "TwenterandWerkt", 
            icon: 'briefcase',
            href: "https://www.twenterandwerkt.nl",
            logo: "/img/projects/twenterandwerkt/twenterandwerkt-logo.svg",
            showInHeader: false,
            categoryIds: [5, 6],
            slug: 'twenterandwerkt',
            metaDescription: 'TwenterandWerkt verbindt werkzoekenden en werkgevers in de regio Twenterand via een lokaal jobplatform met persoonlijke begeleiding.'
        },
        content: {
            title: "TwenterandWerkt",
            subTitle: "Regionaal platform voor bedrijven",
            description: 'Regionaal werkgelegenheidsplatform dat werkzoekenden en werkgevers in de regio Twenterand verbindt met vacatures en talentprofielen.',
            longDescription: 'TwenterandWerkt is een lokaal georiënteerd werkgelegenheidsplatform dat specifiek is ontworpen om werkzoekenden en werkgevers in de regio Twenterand met elkaar te verbinden. Het platform biedt een overzicht van lokale vacatures, cv-matching en regionale arbeidsmarktinformatie om de lokale economie te versterken.',
            subDescription: "Ja, TwenterandWerkt verbindt mensen.",
            extraInfo: "TwenterandWerkt gaat verder dan alleen het matchen van vacatures en werkzoekenden. Het platform biedt ook ondersteuning bij het opstellen van cv's, sollicitatietraining en omscholingskansen. Voor werkgevers zijn er diensten zoals employer branding, pre-screening van kandidaten en regionale arbeidsmarktanalyses.",
            hoverCta: "Van idee tot iets echts"
        },
        style: {
            projectColor: "twenterandwerkt",
            mainColor: "#2980B9"
        },
        media: {
            image: "/img/projects/iMac_24_inch_zilver.webp", 
            sliderImage: "/img/projects/twenterandwerkt/showcaseCard.webp",
            productsPageImage: '/img/projects/twenterandwerkt/projectpageImage.webp',
            mockupImages: {
                mid: { src: "https://www.apple.com/v/mac/mac-does-that/i/images/overview/hero/hero_imac__fkl0k65jazyq_xlarge_2x.png", alt: "Visualisatie van het platform op desktop" },
                left: { src: "https://www.apple.com/v/mac/mac-does-that/i/images/overview/hero/hero_macbook_pro__dxwubu2fr8ia_xlarge_2x.png", alt: "Desktopweergave van het platform" },
                right: { src: "https://www.apple.com/v/mac/mac-does-that/i/images/overview/hero/hero_macbook_air__og7y4ihieoa6_xlarge_2x.png", alt: "Mobiele weergave van het platform" }
            }
        },
        testimonial: {
            question1: "Wat was het grootste misverstand dat je vóór ons nog over 'een goede website' had?",
            answer1: "Ik dacht dat een regionaal platform vooral veel informatie en vacatures moest tonen. Maar het draait allemaal om de juiste verbindingen maken en de lokale gemeenschap te versterken.",
            
            question2: "Hoe heeft TwenterandWerkt de werkgelegenheid in de regio beïnvloed?",
            answer2: "Het platform heeft al meer dan 500 mensen aan een baan geholpen in de regio. Werkgevers waarderen de kwaliteit van de kandidaten, en werkzoekenden zijn blij met de persoonlijke benadering en ondersteuning.",
            
            question3: "Welke functie van het platform heeft volgens jou de meeste impact?",
            answer3: "Zonder twijfel de cv-matching functie. Het is indrukwekkend hoe goed het systeem vacatures en kandidaten op elkaar afstemt.",
            
            question4: "Wanneer dacht je: Oei, dit wordt écht goed?",
            answer4: "Tijdens een bijeenkomst met lokale werkgevers die hun positieve ervaringen deelden. Het moment dat zij zeiden dat ze dankzij ons platform sneller en beter personeel vinden, wist ik dat we op de goede weg zaten.",
            
            question5: "Stel, je belt je toekomstige zelf over deze samenwerking. Wat zeg je dan?",
            answer5: "'Blijf investeren in deze samenwerking, het heeft een enorme impact op de lokale gemeenschap en economie.'",
            
            author: "Gerrit Jansen",
            role: "Wethouder Economische Zaken",
            project: "Werkgelegenheidsplatform",
            image: "/img/testimonials/gerrit-jansen.jpg"
        },
        sections: {
            showcase: {
                1: { title: 'Showcase benaming', description: 'Showcase uitleg komt hier te staan', image: "https://images.unsplash.com/photo-1521791136064-7986c2920216?auto=format&fit=crop&q=80&w=2938&ixlib=rb-4.0.3" },
                2: { title: 'Showcase benaming', description: 'Showcase uitleg komt hier te staan', image: "https://images.unsplash.com/photo-1551836022-d5d88e9218df?auto=format&fit=crop&q=80&w=2940&ixlib=rb-4.0.3" },
                3: { title: 'Showcase benaming', description: 'Showcase uitleg komt hier te staan', image: "https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?auto=format&fit=crop&q=80&w=2940&ixlib=rb-4.0.3" },
            },
            bentoGrid: [
                { title: "Vacatures", heading: "Lokale kansen", description: "Uitgebreid overzicht van werkgelegenheid in de regio Twenterand met geavanceerde zoekfuncties." },
                { title: "Profielen", heading: "Talent showcasen", description: "Persoonlijke profielen voor werkzoekenden om vaardigheden, ervaring en ambities te presenteren." },
                { title: "Matching", heading: "Smart connection", description: "AI-gestuurde matching tussen vacatures en kandidaten op basis van vaardigheden en voorkeuren." },
                { title: "Ontwikkeling", heading: "Groeikansen", description: "Regionale opleidings- en bijscholingsmogelijkheden voor werkzoekenden en werknemers." }
            ]
        }
    },

    { 
        meta: {
            id: 16, 
            name: "MDZK", 
            icon: 'stethoscope',
            href: "https://www.mdzk.nl",
            logo: "/img/projects/mdzk/mdzk-logo.svg",
            showInHeader: false,
            categoryIds: [2, 9],
            slug: 'mdzk',
            metaDescription: 'MDZK biedt een geïntegreerd zorgplatform voor huisartsen en patiënten met online afspraken, consulten en medicatieoverzichten.'
        },
        content: {
            title: "MDZK",
            subTitle: "Evenementen organisatie",
            description: 'Geïntegreerd zorgplatform voor huisartsen en patiënten met online afspraken, consulten, medicatieoverzichten en patiëntendossiers.',
            longDescription: 'MDZK (Medisch Digitaal Zorgkantoor) is een allesomvattend platform dat de communicatie en zorgprocessen tussen huisartsen en patiënten digitaliseert. Het systeem biedt functionaliteiten zoals online afspraken maken, videoconsulten, digitale recepten, medicatieoverzichten en toegang tot patiëntendossiers, allemaal in een veilige en gebruiksvriendelijke omgeving.',
            subDescription: "Ja, MDZK verbetert de zorg.",
            extraInfo: "MDZK zorgt voor een efficiëntere zorgverlening door administratieve processen te automatiseren en communicatie te stroomlijnen. Patiënten kunnen eenvoudig afspraken inplannen, medische vragen stellen via beveiligde berichten en hun eigen gezondheidsgegevens inzien. Voor zorgverleners biedt het platform tijdsbesparing, betere patiëntmonitoring en veilige communicatie met collega's.",
            hoverCta: "Even gluren bij dit project"
        },
        style: {
            projectColor: "mdzk",
            mainColor: "#3498DB"
        },
        media: {
            image: "/img/projects/iMac_24_inch_zilver.webp", 
            sliderImage: "/img/projects/mdzk/showcaseCard.webp",
            productsPageImage: '/img/projects/mdzk/projectpageImage.webp',
            mockupImages: {
                mid: { src: "https://www.apple.com/v/mac/mac-does-that/i/images/overview/hero/hero_imac__fkl0k65jazyq_xlarge_2x.png", alt: "Visualisatie van het platform op desktop" },
                left: { src: "https://www.apple.com/v/mac/mac-does-that/i/images/overview/hero/hero_macbook_pro__dxwubu2fr8ia_xlarge_2x.png", alt: "Desktopweergave van het platform" },
                right: { src: "https://www.apple.com/v/mac/mac-does-that/i/images/overview/hero/hero_macbook_air__og7y4ihieoa6_xlarge_2x.png", alt: "Mobiele weergave van het platform" }
            }
        },
        testimonial: {
            question1: "Wat was het grootste misverstand dat je vóór ons nog over 'een goede website' had?",
            answer1: "Ik dacht dat een medisch platform vooral veel complexe functies moest hebben. Jullie hebben aangetoond dat gebruiksgemak en veiligheid de belangrijkste aspecten zijn voor zowel zorgverleners als patiënten.",
            
            question2: "Hoe heeft MDZK de werkprocessen in je praktijk veranderd?",
            answer2: "We besparen nu ruim 8 uur per week aan administratie. Patiënten plannen zelf hun afspraken, wat onze assistentes enorm ontlast. Ook de digitale recepten en beveiligde berichten hebben onze workflow drastisch verbeterd.",
            
            question3: "Welke functionaliteit heeft volgens jou de grootste impact gehad?",
            answer3: "De online afsprakenmodule heeft onze praktijk getransformeerd. We kunnen nu veel efficiënter werken, hebben minder administratieve belasting en onze patiënten zijn zeer tevreden met de toegankelijkheid die het systeem biedt.",
            
            question4: "Wanneer dacht je: Oei, dit wordt écht goed?",
            answer4: "Tijdens de eerste week na implementatie, toen we merkten dat het aantal telefoontjes met 40% was gedaald terwijl de patiënttevredenheid steeg. Dat was het moment waarop we wisten dat we de juiste keuze hadden gemaakt.",
            
            question5: "Stel, je belt je toekomstige zelf over deze samenwerking. Wat zeg je dan?",
            answer5: "'Blijf investeren in digitale innovatie. De tijd die je terugwint kun je besteden aan wat echt belangrijk is: persoonlijke zorg voor je patiënten.'",
            
            author: "Dr. Marlies Klein",
            role: "Huisarts",
            project: "Digitaal Zorgplatform",
            image: "/img/testimonials/dr-marlies-klein.jpg"
        },
        sections: {
            showcase: {
                1: { title: 'Showcase benaming', description: 'Showcase uitleg komt hier te staan', image: "https://images.unsplash.com/photo-1579154204601-01588f351e67?auto=format&fit=crop&q=80&w=2940&ixlib=rb-4.0.3" },
                2: { title: 'Showcase benaming', description: 'Showcase uitleg komt hier te staan', image: "https://images.unsplash.com/photo-1576091160550-2173dba999ef?auto=format&fit=crop&q=80&w=2940&ixlib=rb-4.0.3" },
                3: { title: 'Showcase benaming', description: 'Showcase uitleg komt hier te staan', image: "https://images.unsplash.com/photo-1666214280391-8ff5bd3c0bf0?auto=format&fit=crop&q=80&w=2940&ixlib=rb-4.0.3" },
            },
            bentoGrid: [
                { title: "Afspraken", heading: "Online planning", description: "Patiënten kunnen 24/7 afspraken inplannen, wijzigen en inzien via het platform." },
                { title: "Consulten", heading: "Digitale zorg", description: "Beveiligde video-consulten en berichtenuitwisseling tussen patiënt en zorgverlener." },
                { title: "Dossier", heading: "Medische gegevens", description: "Veilige toegang tot medische gegevens, uitslagen en medicatieoverzichten voor patiënten." },
                { title: "Integratie", heading: "Verbonden zorg", description: "Koppelingen met apotheken, laboratoria en andere zorgverleners voor gecoördineerde zorg." }
            ]
        }
    },

    { 
        meta: {
            id: 17, 
            name: "Oprecht Manon", 
            icon: 'scale-balanced',
            href: "https://www.oprecht-manon.nl",
            logo: "/img/projects/oprecht-manon/oprecht-manon-logo.svg",
            showInHeader: false,
            categoryIds: [6, 5],
            slug: 'oprecht-manon',
            metaDescription: 'Oprecht Manon biedt juridisch advies en ondersteuning via een toegankelijk online platform met gepersonaliseerde rechtshulp.'
        },
        content: {
            title: "Oprecht Manon",
            subTitle: "Authentieke coaching en persoonlijke ontwikkeling",
            description: 'Online juridisch adviesplatform met persoonlijke rechtshulp, documentgenerators en een kennisbank voor veelvoorkomende juridische kwesties.',
            longDescription: 'Oprecht Manon is een innovatief juridisch platform dat professioneel juridisch advies toegankelijk maakt voor iedereen. Het biedt persoonlijke consultaties, automatische documentgenerators en een uitgebreide kennisbank. Het doel is om juridische hulp laagdrempelig te maken zonder dat gebruikers direct een dure advocaat hoeven in te schakelen.',
            subDescription: "Ja, Oprecht Manon staat voor je klaar.",
            extraInfo: "Oprecht Manon maakt juridische kennis toegankelijk via verschillende kanalen. Gebruikers kunnen vragen stellen via de chat, videogesprekken plannen met juridische experts of de kennisbank raadplegen. Het systeem biedt ook intelligente documentgenerators voor het opstellen van contracten, bezwaarschriften en andere juridische documenten.",
            hoverCta: "Krachtige eenvoud in beeld"
        },
        style: {
            projectColor: "oprecht",
            mainColor: "#8E44AD"
        },
        media: {
            image: "/img/projects/iMac_24_inch_zilver.webp", 
            sliderImage: "/img/projects/oprecht-manon/showcaseCard.webp",
            productsPageImage: '/img/projects/oprecht-manon/projectpageImage.webp',
            mockupImages: {
                mid: { src: "https://www.apple.com/v/mac/mac-does-that/i/images/overview/hero/hero_imac__fkl0k65jazyq_xlarge_2x.png", alt: "Visualisatie van het platform op desktop" },
                left: { src: "https://www.apple.com/v/mac/mac-does-that/i/images/overview/hero/hero_macbook_pro__dxwubu2fr8ia_xlarge_2x.png", alt: "Desktopweergave van het platform" },
                right: { src: "https://www.apple.com/v/mac/mac-does-that/i/images/overview/hero/hero_macbook_air__og7y4ihieoa6_xlarge_2x.png", alt: "Mobiele weergave van het platform" }
            }
        },
        testimonial: {
            question1: "Wat was het grootste misverstand dat je vóór ons nog over 'een goede website' had?",
            answer1: "Ik dacht dat een juridisch adviesplatform vooral veel juridische termen en ingewikkelde procedures moest bevatten. Jullie hebben ons laten zien dat het platform toegankelijk en gebruiksvriendelijk kan zijn.",
            
            question2: "Hoe heeft Oprecht Manon jouw kijk op juridische hulp veranderd?",
            answer2: "Oprecht Manon heeft me doen inzien dat juridische hulp ook eenvoudig en snel kan zijn. Het platform biedt directe toegang tot juridische experts en handige tools die het proces versnellen.",
            
            question3: "Welke functie van Oprecht Manon gebruik je het meest?",
            answer3: "Zeker de documentgenerator. Het is enorm handig om juridische documenten automatisch te laten opstellen op basis van mijn input.",
            
            question4: "Wanneer dacht je: Oei, dit wordt écht goed?",
            answer4: "Tijdens een demonstratie van het platform zag ik hoe snel en efficiënt alles werkte. Het moment dat ik zelf een document genereerde in minder dan vijf minuten, was beslissend.",
            
            question5: "Stel, je belt je toekomstige zelf over deze samenwerking. Wat zeg je dan?",
            answer5: "'Je hebt een slimme zet gedaan. Deze samenwerking opent deuren naar nieuwe mogelijkheden en groei.'",
            
            author: "Manon de Rechtere",
            role: "Advocaat",
            project: "Juridisch Adviseur",
            image: "/img/testimonials/oprecht-manon-logo.png"
        },
        sections: {
            showcase: {
                1: { title: 'Showcase benaming', description: 'Showcase uitleg komt hier te staan', image: "https://images.unsplash.com/photo-1589391886645-d51c2b4117d0?auto=format&fit=crop&q=80&w=2940&ixlib=rb-4.0.3" },
                2: { title: 'Showcase benaming', description: 'Showcase uitleg komt hier te staan', image: "https://images.unsplash.com/photo-1589829545856-d10d557cf95f?auto=format&fit=crop&q=80&w=2940&ixlib=rb-4.0.3" },
                3: { title: 'Showcase benaming', description: 'Showcase uitleg komt hier te staan', image: "https://images.unsplash.com/photo-1450101499163-c8848c66ca85?auto=format&fit=crop&q=80&w=2940&ixlib=rb-4.0.3" },
            },
            bentoGrid: [
                { title: "Advies", heading: "Persoonlijk juridisch advies", description: "Direct contact met juridische experts via chat, video of telefoon voor gepersonaliseerde hulp." },
                { title: "Documenten", heading: "Automatische documentgenerator", description: "Maak juridisch correcte documenten zoals contracten, bezwaarschriften en overeenkomsten." },
                { title: "Kennisbank", heading: "Juridische informatie", description: "Uitgebreide bibliotheek met informatie over veelvoorkomende juridische kwesties en procedures." },
                { title: "Casemanagement", heading: "Zaakbeheer", description: "Volg de voortgang van je juridische kwesties en beheer alle gerelateerde documenten op één plek." }
            ]
        }
    },

    { 
        meta: {
            id: 18, 
            name: "Wevize", 
            icon: 'users-gear',
            href: "https://www.wevize.nl",
            logo: "/img/projects/wevize/wevize-logo.svg",
            showInHeader: false,
            categoryIds: [3, 6],
            slug: 'wevize',
            metaDescription: 'Wevize biedt een platform voor buurtparticipatie waar bewoners samen aan lokale initiatieven kunnen werken en in contact komen met lokale instanties.'
        },
        content: {
            title: "Wevize",
            subTitle: "Projectbeheers platform",
            description: 'Buurtparticipatieplatform dat bewoners verbindt met elkaar en met lokale instanties om samen te werken aan een betere leefomgeving.',
            longDescription: 'Wevize is een buurtparticipatieplatform dat gemeenschappen helpt te floreren door bewoners, lokale ondernemers, verenigingen en overheidsinstanties met elkaar te verbinden. Het platform faciliteert burgerinitiatieven, buurtoverleg en gezamenlijke activiteiten om de sociale cohesie en leefbaarheid van wijken te verbeteren.',
            subDescription: "Ja, Wevize verbindt de buurt.",
            extraInfo: "Het Wevize platform stelt bewoners in staat om ideeën voor te stellen, vrijwilligers te werven, middelen te delen en direct te communiceren met lokale autoriteiten. Het biedt tools voor besluitvorming, crowdfunding voor buurtprojecten en evenementenplanning om de betrokkenheid te vergroten.",
            hoverCta: "Resultaat dat blijft hangen"
        },
        style: {
            projectColor: "wevize",
            mainColor: "#E67E22"
        },
        media: {
            image: "/img/projects/iMac_24_inch_zilver.webp", 
            sliderImage: "/img/projects/wevize/showcaseCard.webp",
            productsPageImage: '/img/projects/wevize/projectpageImage.webp',
            mockupImages: {
                mid: { src: "https://www.apple.com/v/mac/mac-does-that/i/images/overview/hero/hero_imac__fkl0k65jazyq_xlarge_2x.png", alt: "Visualisatie van het platform op desktop" },
                left: { src: "https://www.apple.com/v/mac/mac-does-that/i/images/overview/hero/hero_macbook_pro__dxwubu2fr8ia_xlarge_2x.png", alt: "Desktopweergave van het platform" },
                right: { src: "https://www.apple.com/v/mac/mac-does-that/i/images/overview/hero/hero_macbook_air__og7y4ihieoa6_xlarge_2x.png", alt: "Mobiele weergave van het platform" }
            }
        },
        testimonial: {
            question1: "Wat was het grootste misverstand dat je vóór ons nog over 'een goede website' had?",
            answer1: "Ik dacht dat een buurtplatform vooral door de gemeente aangestuurd moest worden. Jullie hebben laten zien dat echte betrokkenheid ontstaat wanneer bewoners zelf de controle hebben en de tools krijgen om samen te werken.",
            
            question2: "Hoe heeft Wevize de sociale cohesie in je buurt veranderd?",
            answer2: "Het platform heeft mensen bij elkaar gebracht die elkaar anders nooit hadden ontmoet. We zien nu cross-generationele samenwerking, culturele uitwisseling en veel meer verbinding tussen verschillende sociale groepen.",
            
            question3: "Welke functionaliteit van het platform wordt het meest gebruikt?",
            answer3: "De buurtinitiatieven-module wordt verreweg het meest gebruikt. Bewoners hebben al meer dan 30 succesvolle projecten gelanceerd, van buurttuinen tot gezamenlijke energiebesparingsprojecten en culturele evenementen.",
            
            question4: "Wanneer dacht je: Oei, dit wordt écht goed?",
            answer4: "Toen we zagen dat een eenzame oudere via het platform hulp vroeg bij boodschappen, en binnen een uur vijf buurtbewoners hadden gereageerd. Dat was het moment waarop ik wist: dit platform gaat echt iets betekenen voor onze gemeenschap.",
            
            question5: "Stel, je belt je toekomstige zelf over deze samenwerking. Wat zeg je dan?",
            answer5: "'Blijf investeren in deze community. De impact gaat verder dan je nu kunt zien - het platform heeft niet alleen de buurt verbeterd, maar ook de relatie tussen bewoners en lokale instanties fundamenteel veranderd.'",
            
            author: "Annemieke de Vries",
            role: "Buurtcoördinator",
            project: "Buurtparticipatieplatform",
            image: "/img/testimonials/annemieke-de-vries.jpg"
        },
        sections: {
            showcase: {
                1: { title: 'Showcase benaming', description: 'Showcase uitleg komt hier te staan', image: "https://images.unsplash.com/photo-1511632765486-a01980e01a18?auto=format&fit=crop&q=80&w=2940&ixlib=rb-4.0.3" },
                2: { title: 'Showcase benaming', description: 'Showcase uitleg komt hier te staan', image: "https://images.unsplash.com/photo-1573164713714-d95e436ab8d6?auto=format&fit=crop&q=80&w=2940&ixlib=rb-4.0.3" },
                3: { title: 'Showcase benaming', description: 'Showcase uitleg komt hier te staan', image: "https://images.unsplash.com/photo-1536683402757-238c3010670e?auto=format&fit=crop&q=80&w=2940&ixlib=rb-4.0.3" },
            },
            bentoGrid: [
                { title: "Initiatieven", heading: "Ideeën realiseren", description: "Lanceer buurtinitiatieven, werf vrijwilligers en zoek medestanders voor jouw plannen." },
                { title: "Communicatie", heading: "Direct contact", description: "Eenvoudige communicatie tussen bewoners, lokale ondernemers en overheidsinstanties." },
                { title: "Crowdfunding", heading: "Projectfinanciering", description: "Haal gezamenlijk fondsen op voor buurtprojecten en volg de besteding transparant." },
                { title: "Evenementen", heading: "Buurtactiviteiten", description: "Plan, organiseer en promoot buurtactiviteiten om de sociale cohesie te versterken." }
            ]
        }
    },
    
    // ...existing code for other projects if any...
];
